const getAddressByZipCode = (zipCode) =>
    fetch(
        `https://viacep.com.br/ws/${zipCode}/json/`
    ).then((res) => res.json());

export default {
    getAddressByZipCode,
};